import { toNumber } from 'lodash';
import FormData from './state/FormData';
import { getOverrideRanks } from './utilities/careerProgressionHelpers';

const initialFormData = new FormData();

export function applySettingsToDefaults(state, formData) {
  const { reserveComponent, tspSettings } = state.globalSettings;

  formData.withdrawalAgeYears = tspSettings.withdrawalAgeYearDefault;
  formData.withdrawalAgeMonths = tspSettings.withdrawalAgeMonthDefault;
  formData.contributionRate = toNumber(tspSettings.defaultContributionRate);
  formData.growthRate = toNumber(tspSettings.growthRate);
  formData.growthRateDisplay = tspSettings.growthRate;
  formData.withdrawalGrowthRate = toNumber(tspSettings.withdrawalGrowthRate);
  formData.withdrawalGrowthRateDisplay = tspSettings.withdrawalGrowthRate;
  formData.retirementAgeYears = reserveComponent.nonRegularRetirementCommencePayAtAgeYear;
  formData.retirementAgeMonths = reserveComponent.nonRegularRetirementCommencePayAtAgeMonth;
}

const mutations = {
  setStepIndex(state, stepIndex) {
    state.currentStepIndex = stepIndex;
  },

  setAltMode(state, altMode) {
    state.currentStepAltMode = altMode;
  },

  setFormData(state, data) {
    state.formData = { ...state.formData, ...data };
  },

  setStepLoading(state, stepLoading) {
    state.stepLoading = stepLoading;
  },

  resetFormData(state) {
    state.formData = { ...state.formData, ...initialFormData };
  },

  setSameAsPayDate(state, value) {
    state.sameAsPayDate = value;
  },

  setGlobalSettings(state, data) {
    state.globalSettings = data;
  },

  setModuleSettings(state, data) {
    state.moduleSettings = data;
  },

  setSteps(state, steps) {
    state.steps = steps.map((step, index) => ({ ...state.steps[index], ...step }));
  },

  setMoreInfo(state, moreInfo) {
    state.moreInfo = moreInfo;
  },

  setTooltips(state, tooltips) {
    state.tooltips = tooltips;
  },

  setPayTables(state, data) {
    state.payTables = data;
  },

  applySettingsToDefaults(state) {
    applySettingsToDefaults(state, initialFormData);
  },

  setServiceMember(state, data) {
    state.serviceMember = data;
  },

  updateYearOfServiceRankCareerService(state, { yearOfServiceRank, index }) {
    const careerProgressionCareerService = state.serviceMember.careerProgression.careerService;
    for (let i = index; i < careerProgressionCareerService.length; i += 1) {
      const currentItem = careerProgressionCareerService[i];
      currentItem.yearOfServiceRank = yearOfServiceRank;
    }
  },

  updateOverrideRanksCareerService(state, { yearOfServiceRank, index }) {
    const careerProgressionCareerService = state.serviceMember.careerProgression.careerService;
    for (let i = index + 1; i < careerProgressionCareerService.length; i += 1) {
      const currentItem = careerProgressionCareerService[i];
      const overrideRanks = getOverrideRanks(
        yearOfServiceRank,
        currentItem.yearOfService,
      );
      currentItem.overrideRanks = overrideRanks;
    }
  },

  updateReserveComponentCareerService(state, { key, value, index }) {
    const { reserveComponent } = state.serviceMember.careerProgression.careerService[index];
    reserveComponent[key] = value;
  },

  validateReserveComponentCareerService(state, { isValid, index }) {
    const { reserveComponent } = state.serviceMember.careerProgression.careerService[index];
    reserveComponent.isValid = isValid;
  },

  setBornDateOptions(state, data) {
    state.bornDateOptions = data;
  },

  setPayEntryBaseDateOptions(state, data) {
    state.payEntryBaseDateOptions = data;
  },

  setActiveServiceDateOptions(state, data) {
    state.activeServiceDateOptions = data;
  },

  setRetirementSTOptions(state, data) {
    state.retirementSTOptions = data;
  },

  setTransferToRcOptions(state, data) {
    state.transferToRcOptions = data;
  },

  setTransferToAcOptions(state, data) {
    state.transferToAcOptions = data;
  },

  setQualifyingYearsOptions(state, data) {
    state.qualifyingYearsOptions = data;
  },

  setLifeExpectancyOptions(state, data) {
    state.lifeExpectancyOptions = data;
  },

  setWithdrawalAgeOptions(state, data) {
    state.withdrawalAgeOptions = data;
  },

  setRetirementAgeOptions(state, data) {
    state.retirementAgeOptions = data;
  },
};

export default mutations;
